import { Box, Container, Link, Typography } from "@mui/material";
import styled from "@emotion/styled";
import DemoInput from "./components/DemoInput";
import DemoDialog from "./components/DemoDialog";
import DemoStatus from "./components/DemoStatus";
import DemoAppLink from "./components/DemoAppLink";

export const DemoBox = styled(Box)({
  "& > *": {
    marginBottom: 16,
  },
});

const DemoPage = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Almost component base on:
        <Link href="https://mui.com/material-ui/react-autocomplete/" underline="none">
          MUI_v5
        </Link>
      </Typography>
      <DemoBox>
        <Typography variant="h6">Input</Typography>
        <DemoInput />
      </DemoBox>
      <DemoBox>
        <Typography variant="h6">Dialog</Typography>
        <DemoDialog />
      </DemoBox>
      <DemoBox>
        <Typography variant="h6">Status</Typography>
        <DemoStatus />
      </DemoBox>
      <DemoBox>
        <Typography variant="h6">AppLink + MenuItem</Typography>
        <DemoAppLink />
      </DemoBox>
      <DemoBox>
        <Typography variant="h6">Other</Typography>
      </DemoBox>
    </Container>
  );
};

export default DemoPage;
